<div class="main-banner">
    <div id="spacer"></div>
    <figure>
        <a href="https://dribbble.com/shots/5484687-KSRTC-Bus-Kerala" target="_blank">
            <img id="banner-img" alt="Main banner image" src="assets/images/ksrtc_bus_kerala.png">
        </a>
        <figcaption>Illustration by Deepak Kumar on dribbble</figcaption>
    </figure>
    <div id="spacer"></div>
</div>